<template>
  <div>
    <v-toolbar flat height="50" dark color="deep-purple">
      <v-toolbar-title>{{ title }}</v-toolbar-title>
      <v-spacer></v-spacer>
      <v-btn fab x-small depressed color="transparent" @click="onClose()"><v-icon>mdi-close</v-icon></v-btn>
    </v-toolbar>

    <v-card flat class="rounded-0" color="light-grey">
      <v-sheet :style="contentsHeight">
        <v-row align="center" class="px-4">
          <v-col cols="4">
            <v-btn @click="getServer()">Server</v-btn>
          </v-col>
          <v-spacer></v-spacer>
          <v-col cols="4">
            <v-select
              ref="project"
              :items='projects'
              label="Project"
              v-model='project'
              item-text="name"
              item-value="id"
              hideDetails
              solo
              :rules="[rules.required]"
            ></v-select>
          </v-col>
        </v-row>
        <v-row align="center" class="px-4" v-if="_schools.length > 1">
          <v-col cols="4">
            <v-select
              ref="_schools"
              :items='_schools'
              label="School"
              v-model='school'
              item-text="name"
              item-value="key"
              hideDetails
              solo
              dense
              :rules="[rules.required]"
            >
            <template v-slot:selection="{ item }">
              <v-card-text class="pa-0" :style="item.enable ? 'color: black;' : 'color: red;'">{{ item.name}}</v-card-text>
            </template>
            <template v-slot:item="{ item }">
              <v-card-text class="pa-0" :style="item.enable ? 'color: black;' : 'color: red;'">{{ item.name}}</v-card-text>
            </template>
            </v-select>
          </v-col>
          <v-col cols="2" align="end">{{ _schools_enable.length + ' / ' + _schools.length }}</v-col>
          <v-spacer></v-spacer>
          <v-col cols="auto">
            <v-btn :disabled="!school" color="primary" icon @click="dialogCheckUp = true"><v-icon>mdi-bug</v-icon></v-btn>
          </v-col>
        </v-row>
        <v-divider class="mx-4"></v-divider>
      </v-sheet>
    </v-card>

    <div v-if="dialogCheckUp" class="text-center">
      <v-dialog
        v-model="dialogCheckUp"
        hide-overlay
        fullscreen
        transition="dialog-bottom-transition"
        scrollable
        >
        <diagnose-checkup
          :title="'Diagnose Check Up'"
          :metrics_status="metrics_status"
          :schools="schools"
          :school="school"
          @dismissed="onDismissed">
        </diagnose-checkup>
      </v-dialog>
    </div>

    <div>
      <loading-with-status :loading="loading" :status="status"></loading-with-status>
    </div>

  </div>
</template>

<script>
import Vue from 'vue'
// import * as async from 'async'
import { mapGetters } from 'vuex'
import axios from 'axios'
import firebase from 'firebase/app'
import 'firebase/auth'
import LoadingWithStatus from './Loading.vue'
import TemplateDiagnoseStudent from './TemplateDiagnoseStudent.vue'
import TemplateDiagnoseCheckUp from './TemplateDiagnoseCheckUp.vue'
Vue.component('loading-with-status', LoadingWithStatus)
Vue.component('diagnose-student', TemplateDiagnoseStudent)
Vue.component('diagnose-checkup', TemplateDiagnoseCheckUp)

export default {
  computed: {
    ...mapGetters({
      user: 'auth/user',
      data: 'auth/data',
      windowSize: 'shared/windowSize'
    }),
    _schools () {
      var temp = []
      for (var x in this.schools) {
        temp.push(JSON.parse(JSON.stringify(this.schools[x])))
      }
      temp.sort(function (a, b) {
        if (a.name < b.name) return -1
        if (a.name > b.name) return 1
        return 0
      })
      temp.unshift({ key: '*', name: 'all' })
      return temp
    },
    _schools_enable () {
      var temp = this._schools.filter(item => item.enable)
      return temp
    },
    contentsHeight () {
      return 'background: transparent; height: ' + String(this.windowSize.y - 50) + 'px;'
    }
  },
  props: ['title'],
  data () {
    return {
      loading: false,
      dialogCheckUp: false,
      status: '',
      path: null,
      project: null,
      school: null,
      schools: [],
      metrics_status: [],
      schedule_events: [],
      template_events: [],
      schedule_events_temp: [],
      template_events_temp: [],
      projects: [
        { name: 'realte-prod', id: 'realte-prod' },
        { name: 'realte-dev', id: 'realte-dev' },
        { name: 'global-vision-prod', id: 'global-vision-prod' },
        { name: 'global-vision-dev', id: 'global-vision-dev' }
      ],
      rules: {
        required: value => !!value || '必須'
      }
    }
  },
  watch: {
    schools () {
    },
    groups () {
    }
  },
  created () {
  },
  methods: {
    async getServer () {
      // var vm = this
      await this.getFirestore('schools')
      // await this.getFirestore('metrics_status')
      // await this.getFirestore('schedule_events')
      // await this.getFirestore('template_events')
      // var s = { gBTaGgVxtSbZPjE2hV1G: true }
      // for (var x in this.template_events) {
      //   if (this.template_events[x].schools['gV0EeXcIPYGHY3Gl6g6N']) {
      //     this.template_events[x].schools = s
      //     this.template_events_temp.push(JSON.parse(JSON.stringify(this.template_events[x])))
      //   }
      // }
      // for (x in this.schedule_events) {
      //   if (this.schedule_events[x].schools['gV0EeXcIPYGHY3Gl6g6N']) {
      //     this.schedule_events[x].schools = s
      //     this.schedule_events_temp.push(JSON.parse(JSON.stringify(this.schedule_events[x])))
      //   }
      // }

      // async.eachSeries(this.schedule_events_temp, function (item, cb) {
      //   vm.$store.dispatch('scheduleEvents/write', JSON.parse(JSON.stringify(item))).then((resp) => {
      //     const pause = ms => new Promise(resolve => setTimeout(resolve, ms))
      //     pause(50).then(() => {
      //       cb()
      //     })
      //   })
      // }, function (error) {
      //   if (error) {
      //   }
      // })

      // async.eachSeries(this.template_events_temp, function (item, cb) {
      //   vm.$store.dispatch('templateEvents/write', JSON.parse(JSON.stringify(item))).then((resp) => {
      //     const pause = ms => new Promise(resolve => setTimeout(resolve, ms))
      //     pause(50).then(() => {
      //       cb()
      //     })
      //   })
      // }, function (error) {
      //   if (error) {
      //   }
      // })
    },
    getFirestore (path) {
      var vm = this
      return new Promise(async (resolve) => {
        if (!(this.$refs.project.validate(true))) {
          resolve()
          return
        }

        vm.loading = true
        vm.status = 'Loading ... /' + path
        var payload = { path: path, id: vm.project }
        var url = vm.$FUNCTIONS_URL + '/firestore/get'

        firebase.auth().currentUser.getIdToken().then(function (token) {
          axios.post(url, payload, {
            headers: { 'Authorization': `Bearer ${token}` }
          }).then(function (response) {
            if (response.data.data) {
              vm[path] = []
              for (var x in response.data.data) {
                vm[path].push(JSON.parse(JSON.stringify(response.data.data[x])))
              }
            }
            resolve()
            vm.loading = false
          }).catch(function (error) {
            if (error) {
            }
            resolve()
            vm.loading = false
          })
        })
      })
    },
    onClose () {
      this.$emit('dismissed')
    },
    onDismissed: function (value) {
      if (this.dialogCheckUp) {
        this.dialogCheckUp = false
      }
    }
  }
}
</script>

<style scoped>
</style>
